<template>
  <div>
    <div class="form-row my-2 facility">
      <div class="form-group col-md-5 mb-1">
        <currency-input
          placeholder="Amount"
          v-model="facility.amount"
          class="form-control amount"
        />
      </div>
      <div class="form-group col-md-5 mb-1">
        <input
          type="text"
          class="form-control institution"
          v-model="facility.institution"
          placeholder="Company / Bank Info"
        />
      </div>
      <div class="form-group col-md-1 text-center mt-2">
        <img
          v-on:click="remove(index)"
          src="@/assets/img/delete.svg"
          alt="delete"
          class="ibtnDel mt-3 pt-1"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "LoanFacility",
  props: {
    facility: Object,
    index: Number
  },
  data: () => ({}),
  methods: {
    remove(index) {
      this.$emit("removeExistingLoanFacility", index);
    }
  }
};
</script>
